"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Profile = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _UpdateEmailForm = require("./UpdateEmailForm");
var _utils = require("../../../../utils");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledAlert = (0, _styledComponents.default)(_ui.Alert)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 80%;\n  margin-top: 14px;\n"])));
var StyledSmall = (0, _styledComponents.default)(_ui.Small)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  line-height: 24px;\n"])));
var Profile = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    showContactSupportAlert = _ref.showContactSupportAlert,
    children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_UpdateEmailForm.UpdateEmailForm, null)), children, showContactSupportAlert && /*#__PURE__*/_react.default.createElement(StyledAlert, {
    component: StyledSmall,
    iconColor: "danger"
  }, t('profileSettingsAttention')));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), _utils.mediaQuery.greaterThan('md')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    max-width: 502px;\n  "]))));
exports.Profile = Profile;